import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import portalware from './imgs/portalware.png';
import crochetmatic from './imgs/crochetmatic.jpg';
import smstfeditor from './imgs/smstfeditor.png';
import pathtracer from './imgs/pathtracer.jpg';
import surfacebrush from './imgs/surfacebrush.gif';
import teapot from './imgs/teapot.png';
import lechat from './imgs/lechat.png';
import tiletunes from './imgs/tiletunes.png';
import discobot from './imgs/discobot.png';
import pvdcm from './imgs/pvdcm.png';
import wicshistory from './imgs/wicshistory.png';

class Portfolio extends Component {
  render() {
    return(
      <div className="App-body-portfolio">
        <h2>research</h2>
        <div className="App-body-portfolio-items">
          <div>
            <NavLink to="/portalware">
              <input type="image" src={portalware} alt="Portalware"/>
              <h3>Portalware</h3>
            </NavLink>
            <p>HCI, Graphics, UI/UX</p>
          </div>
          <div>
            <NavLink to="/crochetmatic">
              <input type="image" src={crochetmatic} alt="CrochetMatic"/>
              <h3>CrochetMatic</h3>
            </NavLink>
            <p>Graphics, HCI</p>
          </div>
        </div>
        <h2>computer graphics & visualization</h2>
        <div className="App-body-portfolio-items">
          <div>
            <NavLink to="/smstfeditor">
              <input type="image" src={smstfeditor} alt="SMS TF Editor"/>
              <h3>Small Multiples Sequence TF Editor</h3>
            </NavLink>
            <p>Visualization, HCI, UI/UX</p>
          </div>
          <div>
            <NavLink to="/pathtracer">
              <input type="image" src={pathtracer} alt="Path Tracer"/>
              <h3>Path Tracer</h3>
            </NavLink>
            <p>Graphics</p>
          </div>
          <div>
            <NavLink to="/surfacebrush">
              <input type="image" src={surfacebrush} alt="SurfaceBrush"/>
              <h3>SurfaceBrush</h3>
            </NavLink>
            <p>Graphics</p>
          </div>
        </div>
        <h2>computer animation</h2>
        <div className="App-body-portfolio-items">
          <div>
            <NavLink to="/lechat">
              <input type="image" src={lechat} alt="Le Chat"/>
              <h3>Le Chat</h3>
            </NavLink>
            <p>Animation</p>
          </div>
          <div>
            <NavLink to="/teapot">
              <input type="image" src={teapot} alt="Teapot"/>
              <h3>Teapot</h3>
            </NavLink>
            <p>Animation</p>
          </div>
        </div>
        <h2>physical computing</h2>
        <div className="App-body-portfolio-items">
          <div>
            <NavLink to="/tiletunes">
              <input type="image" src={tiletunes} alt="Tile Tunes"/>
              <h3>Tile Tunes</h3>
            </NavLink>
            <p>HCI, UI/UX, Music</p>
          </div>
          <div>
            <NavLink to="/discobot">
              <input type="image" src={discobot} alt="Disco Bot"/>
              <h3>Disco Bot</h3>
            </NavLink>
            <p>HRI, UI/UX, Music</p>
          </div>
        </div>
        <h2>ui/ux</h2>
        <div className="App-body-portfolio-items">
          <div>
            <NavLink to="/pvdcm">
              <input type="image" src={pvdcm} alt="Providence Children's Museum
              Redesign"/>
              <h3>Providence Children's Museum Redesign</h3>
            </NavLink>
            <p>UI/UX</p>
          </div>
          <div>
            <NavLink to="/wicshistory">
              <input type="image" src={wicshistory} alt="History of Women in
              Computer Science"/>
              <h3>History of Women in Computer Science</h3>
            </NavLink>
            <p>UI/UX, Outreach</p>
          </div>
        </div>
      </div>
    );
  }
}

export default Portfolio;
